import React from 'react';
import { Box, Grid, Container, Typography } from '@mui/material';
import i18n from 'i18n-js';
import Layout from 'components/Layout';
import { useParams } from 'react-router-dom';
import { PromoCodeDetails as Details, PromoCodeAccounting } from 'components/PromoCodes';
import Comments from 'components/Comments';
import Logs from 'components/Logs';
import { useSelector } from 'react-redux';

const PromoCodeDetails = () => {
  const { id } = useParams();
  const { promoCode } = useSelector((state) => state.promoCodes);

  return (
    <Layout title={i18n.t('promo_codes.title')}>
      <Container sx={{ minWidth: '100%', margin: 0 }}>
        <Grid container spacing={2} p={0}>
          <Grid item size={12} sx={{ pt: 2 }}>
            <Grid container direction="row" justifyContent="space-between" spacing={2}>
              <Grid item>
                <Typography variant="h6" gutterBottom>
                  <Box fontWeight="fontWeightBold" fontSize={24} my={1}>
                    {i18n.t('promo_codes.details_title') + id}
                  </Box>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item size={12}>
            <Grid container spacing={4}>
              <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                <Grid container spacing={2}>
                  <Grid item size={12}>
                    <Details id={id} />
                  </Grid>
                  <Grid item size={12}>
                    <PromoCodeAccounting id={promoCode?.invoice_item_type_id} promoCode={id} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                <Grid container spacing={2}>
                  <Grid item size={12}>
                    <Comments type="promotional_code" id={parseInt(id)} />
                  </Grid>
                </Grid>
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 4 }}>
                <Grid container spacing={2}>
                  <Grid item size={12}>
                    <Logs
                      title={i18n.t('promo_codes.logs')}
                      targetType={'PromotionalCode'}
                      targetId={id}
                      height={400}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Layout>
  );
};

export default PromoCodeDetails;
